/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Getting_StartedInputs */

const en_settings_overview_getting_started = /** @type {(inputs: Settings_Overview_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Started`)
};

const zh_settings_overview_getting_started = /** @type {(inputs: Settings_Overview_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用`)
};

/**
* | output |
* | --- |
* | "Getting Started" |
*
* @param {Settings_Overview_Getting_StartedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_getting_started = /** @type {((inputs?: Settings_Overview_Getting_StartedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Getting_StartedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_getting_started(inputs)
	return zh_settings_overview_getting_started(inputs)
});
export { settings_overview_getting_started as "settings.overview.getting_started" }